import axios from 'axios'

export default {
  getAll: async sitePath => {
    const url = `${sitePath}/user/`
    // site is the last path of sitePath
    // /1/2/3 --> 3
    const site = (''+sitePath).indexOf('/') >= 0 ? sitePath.split('/').slice(-1)[0] : sitePath;
    const params = { site }
    const response = await axios.get(url, { params })

    return response.data
  },

  delete: async (sitePath, id) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/user/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/user/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },

  current: async () => {
    const url = `/user_data/me/`;
    const response = await axios.get(url);
    return response.data;
  },

  postUser: async (sitePath, formData) => {
    const url = `${sitePath}/user/`
    let response = await axios.post(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    return response.data
  },

  putUser: async (sitePath, id, formData) => {
    const url = `${sitePath}/user/${id}/`
    let response = await axios.put(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    return response.data
  },

  get_manager_actions(user,select_items) {
    const boolean_entries = [['false','False'],['true','True']];
    const modify_user = {
      'id': 'modify',
      'layout': [
        [
          {
            id: 'username',
            label: 'Username',
            required: true,
            value: user.username,
            readonly: true,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter username',
          },
          /*{
            id: 'password',
            label: 'Password',
            required: this.new_user,
            value: user.password,
            is_password: true,
            readonly: true,
            hidden: true,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter password',
          },*/
          {
            id: 'email',
            label: 'Email',
            required: true,
            value: user.email,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter email',
            is_email: true,
          },
        ],
        [
        {
            id: 'first_name',
            label: 'Name',
            required: true,
            value: user.first_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter name',
          },
          {
            id: 'last_name',
            label: 'Last name',
            required: true,
            value: user.last_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter last name',
          },
          {
            id: 'lang',
            label: 'Languaje',
            required: true,
            value: user.lang,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: '',
            items: [['es','Spanish'],['ca','Catalan'], ['en','English']],
          },
        ],
        [
          {
            id: 'is_active',
            label: 'Enabled',
            required: false,
            value: user.is_active,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
          },
          {
            id: 'email_notifications',
            label: 'Send notification emails',
            required: false,
            value: user.email_notifications,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
          },
          {
            id: 'internal_notifications',
            label: 'Send internal notifications',
            required: false,
            value: user.internal_notifications,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
          },
        ],
        [
          {
            id: 'isManager',
            label: 'Manager',
            required: false,
            value: user.isManager,
            readonly: true,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
            hidden: true,
          },
          {
            id: 'isAdmin',
            label: 'Admin',
            required: false,
            value: user.isAdmin,
            readonly: true,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
            hidden: true,
          },
          {
            id: 'chat',
            label: 'Support chat',
            required: false,
            value: (user.support_level || {}).chat,
            readonly: true,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
            placeholder: '',
            items: boolean_entries,
            hidden: true,
          },
        ],
        [
        {
            id: 'preferred_centro',
            label: 'Preferred Centro',
            required: false,
            value: user.preferred_centro,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'AutocompleteSelect',
            placeholder: 'Choose user preferred centro',
            items: ((select_items || {}).modify_user || {}).preferred_centro || [],//this.get_user_centros(this.currentEditUser).map((val) => [val.id, val.name]),
            multiple: false,
          },
        ],
        [
          {
            id: 'photo',
            label: 'Photo',
            required: false,
            value: user.photo,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          },
        ],
        [
          {
            id: 'warning1',
            label: "Remember that user roles are managed in the centers space",
            required: false,
            value: "",
            readonly: true,
            hidden: null,
            cols: 4,
            class: 'warning',
            component: 'Tag',
            placeholder: '',
          },
        ]
      ],
      'label': 'Modify',
    };

    const change_password = {
      'id': 'change_password',
      'layout': [
        [
          {
            id: 'user',
            label: 'User',
            required: true,
            value: user.first_name + ' ' + user.last_name,
            readonly: true,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
          },
          {
            id: 'password',
            label: 'Password',
            required: true,
            value: null,
            is_password: true,
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter password',
          }
        ],
        modify_user.layout.flat().map(it => ({...it, 'hidden': true}))
      ],
      'label': 'Change password',
    };
    const change_roles = {
      'id': 'change_roles',
      'layout': [
        [
          {
            id: 'user',
            label: "User",
            required: true,
            value: user.first_name + ' ' + user.last_name,
            readonly: true,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: "",
          },
          {
            id: 'roles',
            label: "User roles",
            required: false,
            value: ((select_items || {}).change_roles || {}).roles_value || null,
            readonly: false,
            cols: 8,
            class: null,
            component: 'GenericTreeviewSelect',
            placeholder: "",
            items: ((select_items || {}).change_roles || {}).roles_items || [],
            multiple: true,
            chips: true,
            group_id: 'department',
            group_name: 'department_name',
          },
        ],

      ],
      'label': 'Change roles',
      // TODO: find another way to give a function to submit. This one is for the user roles on a center
      'object_submit': 'QCentro',
    };



    return {'actions': true,'transition_candidates': [modify_user, change_password, change_roles]};
  },
}
